<div class="detail-table-row-wrapper">
	<table
		mat-table
		aria-label="table"
		class="ob-table ob-table-plain no-link-decoration"
		id="channel-link-table"
		matSort
		matSortDisableClear
		[dataSource]="dataSource"
	>
		<ng-container [matColumnDef]="COLUMN_SELECT">
			<th mat-header-cell *matHeaderCellDef>
				<mat-checkbox
					id="channel-link-checkbox-all"
					(change)="$event ? onMasterToggle() : null"
					[checked]="hasSelectedRows() && isAllSelected()"
					[indeterminate]="hasSelectedRows() && !isAllSelected()"
					[disabled]="isEditMode()"
					matTooltip="{{ 'i18n.tooltip.checkbox_all' | translate }}"
				>
				</mat-checkbox>
			</th>
			<td mat-cell *matCellDef="let row; let i = index">
				<mat-checkbox
					id="channel-link-checkbox-{{ i }}"
					(click)="$event.stopPropagation()"
					(change)="$event ? onToggleSelection(row) : null"
					[checked]="isRowSelected(row)"
					[disabled]="isEditMode()"
					matTooltip="{{ 'i18n.tooltip.checkbox_single' | translate }}"
				>
				</mat-checkbox>
			</td>
		</ng-container>

		<ng-container [matColumnDef]="COLUMN_NAME">
			<th mat-header-cell *matHeaderCellDef>{{ "i18n.property.name" | translate }}</th>
			<td mat-cell *matCellDef="let element; let i = index">
				<mat-form-field [hidden]="!isRowEditMode(i)">
					<input
						id="channel-link-name-{{ i }}"
						type="text"
						matInput
						required
						[formControl]="filteredControl"
						[matAutocomplete]="auto"
						(change)="onChange(element, $event, COLUMN_NAME)"
					/>
					<mat-autocomplete #auto="matAutocomplete" [displayWith]="displayValue">
						@for (agent of filteredlinkableAgents$ | async; track agent) {
							<mat-option [value]="agent" (onSelectionChange)="onChange(element, agent, COLUMN_NAME)">
								<span>{{ agent.name | fallback: currentLanguage }}</span>
							</mat-option>
						}
					</mat-autocomplete>
					@if (filteredControl.errors?.required) {
						<mat-error>{{ "i18n.error.required" | translate }}</mat-error>
					}
					@if (filteredControl.errors?.valueIsIncluded) {
						<mat-error>{{ "i18n.multilingual.error.publisher" | translate }}</mat-error>
					}
				</mat-form-field>
				<span>{{ element.name | fallback: currentLanguage }}</span>
			</td>
		</ng-container>

		<ng-container [matColumnDef]="COLUMN_ACTIONS">
			<th mat-header-cell mad-sort-header *matHeaderCellDef>
				<div class="action-wrapper">
					<div class="action-button">
						<button
							id="channel-link-delete-selected"
							obButton="secondary"
							mat-icon-button
							matTooltip="{{ 'i18n.tooltip.delete_selected' | translate }}"
							(click)="onRemoveSelectedRows()"
							[disabled]="hasSelectedRows() === false"
						>
							<mat-icon svgIcon="link_disconnect" class="ob-icon"></mat-icon>
						</button>
					</div>
					<div class="action-button">
						<button
							id="channel-link-addrow"
							obButton="secondary"
							mat-icon-button
							(click)="onAddRow()"
							[disabled]="!canAdd()"
							matTooltip="{{ 'i18n.tooltip.addrow' | translate }}"
						>
							<mat-icon svgIcon="plus" class="ob-icon"></mat-icon>
						</button>
					</div>
				</div>
			</th>
			<td mat-cell *matCellDef="let row; let i = index">
				<div class="action-wrapper">
					@if (isRowEditMode(i)) {
						<div class="action-button">
							<button
								id="hannel-link-discard-{{ i }}"
								obButton="secondary"
								mat-icon-button
								(click)="onDiscard()"
								[disabled]="hasSelectedRows()"
								matTooltip="{{ 'i18n.tooltip.discard' | translate }}"
							>
								<mat-icon svgIcon="xmark" class="ob-icon"></mat-icon>
							</button>
						</div>
					}
					@if (isRowEditMode(i)) {
						<div class="action-button">
							<button
								id="hannel-link-save-{{ i }}"
								obButton="secondary"
								mat-icon-button
								(click)="onSave(i)"
								[disabled]="!canSave(i)"
								matTooltip="{{ 'i18n.tooltip.save' | translate }}"
							>
								<mat-icon svgIcon="checkmark" class="ob-icon"></mat-icon>
							</button>
						</div>
					}
					@if (canRemove()) {
						<div class="action-button">
							<button
								id="hannel-link-unlinkbutton-{{ i }}"
								obButton="secondary"
								mat-icon-button
								(click)="onRemoveRow(i)"
								[disabled]="hasSelectedRows()"
								matTooltip="{{ 'i18n.tooltip.unlink' | translate }}"
							>
								<mat-icon svgIcon="link_disconnect" class="ob-icon"></mat-icon>
							</button>
						</div>
					}
				</div>
			</td>
		</ng-container>

		<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
		<tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
	</table>

	<div class="table-info-box">
		<app-infobox-no-content [datasource]="dataSource.data"></app-infobox-no-content>
	</div>
</div>
